import { render } from "./ThePaymentServicesPaymentTypeBlocker.vue?vue&type=template&id=2d48c8a0&scoped=true"
import script from "./ThePaymentServicesPaymentTypeBlocker.vue?vue&type=script&lang=js"
export * from "./ThePaymentServicesPaymentTypeBlocker.vue?vue&type=script&lang=js"

import "./ThePaymentServicesPaymentTypeBlocker.vue?vue&type=style&index=0&id=2d48c8a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d48c8a0"]])

export default __exports__